<!----------------------------   Program description   ----------------------------
- Vue Name ID   :   addOrderPopup
- Vue Name  :   addOrderPopup
- Author      :
- Create Date : 2021.04.30
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
  <div v-if="showAt">
    <section id="step">
      <div :class="[step>=5?'comp':'','grid--step']">
        <div class="pt-step">
          <ul>
            <li :class="[step>=1?'current':'',step>1?'step':'']"><span>01.상품구매</span></li><!--
            --><li :class="[step>=2?'current':'',step>2?'step':'']"><span>02.배송지 입력</span></li><!--
            --><li :class="[step>=3?'current':'',step>3?'step':'']"><span>03.결제금액 확인</span></li><!--
            --><li :class="[step>=4?'current':'',step>4?'step':'']"><span>04.결제</span></li><!--
            --><li :class="[step>=5?'current':'',step==5?'last-step':'']"><span>05.상품구매신청완료</span></li>
          </ul>
        </div>
      </div>
    </section>
    <div class="layer-content">
      <!-- 상품 주문 -->
      <div v-if="step == 1">
        <div class="info2"
             style="display: inline-block;">
          구매하실 <span class="pc01">상품 선택 및 수량 입력</span>을 해주세요.
        </div>
        <div class="f-right txt-type4 pd3">
          리더기 설치시 전기작업이 필요한 경우 별도견적 드립니다.
        </div>
        <div>
          <ul class="balance-sort-wrap"
              style="margin:-5px;flex-wrap:wrap">
            <li class="balance-sort-con"
                style="padding:5px;width:50%;flex:none;box-sizing: border-box;"
                v-for="(info,index) in goods.goodsList"
                :key="'info' + index" >
              <table class="tb-row">
                <colgroup>
                  <col style="width:8%;">
                  <col style="width:20%;">
                  <col style="width:15%;">
                  <col style="width:2%;">
                  <col style="width:28%;">
                  <col style="width:25%;">
                </colgroup>
                <tbody>
                <tr>
                  <th rowspan="2">
                    <input type="checkbox"
                           v-model="info.chkAt"
                           :id="'goods_chk_'+index"
                           @change="goodsChkChange(index)"/>
                    <label class="mg0"
                           :for="'goods_chk_'+index">
                      <span class="box"></span>
                    </label>
                  </th>
                  <td rowspan="2"
                      style="padding: 5px !important;text-align: center;">
                    <img style="border: 1px solid #efefef;width: 80px;height: 80px"
                         :src="$onbiLib.getImageFileUrl('', info.fileNm, info.savePath, info.extsn, '')">
                  </td>
                  <td colspan="3">{{ info.goodsNm }}</td>
                  <td rowspan="2"
                      class="__center"
                      style="font-size: 18px;"
                      v-html="getGoodsSumAmountTxt(info)">
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    금액 : {{$onbiLib.addComma(info.amount)}}원
                    <span class="pdl10 pdr10">X  </span>
                    <input type="text"
                           maxlength="3"
                           style="width: 40px;height: 22px;line-height: 23px;padding: 0;font-size: 14px;margin-top: -5px;text-align: center"
                           :disabled="!info.chkAt||info.goodsNo == 2"
                           :ref="'goodsAmount'+index"
                           v-model="info.orderQy"
                           :tabindex="index+1"
                           @input="setOrderDscntAmount(info)"
                           @keydown="$onbiLib.onlyNumberKeydown()"
                           @keyup="$onbiLib.onlyNumberKeyup()"/><span class="pdl10">개</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </li>
          </ul>
        </div>
        <div class="sv-req-price-comp mgt20">
          <span>합계 금액 : {{$onbiLib.addComma(chkGoodsSumAmount)}}원</span>
        </div>
        <div class="btn-wrap mgt20 t-line center">
          <button class="big _bt-navy"
                  @click="goodsNextStep()">
            <span>다음</span>
          </button>
        </div>
      </div>

      <!-- 배송지 입력 -->
      <div v-if="step == 2">
        <table class="tb-row instt-tbl">
          <colgroup>
            <col style="width: 17%">
            <col style="width: 33%">
            <col style="width: 17%">
            <col style="width: 33%">
          </colgroup>
          <tbody>
          <tr>
            <th class="__left">수령인 이름</th>
            <td>
              <input type="text"
                     style="width:300px;"
                     ref="rcverNm"
                     v-model="dlvy.rcverNm">
            </td>
            <th class="__left">수령인 연락처</th>
            <td style="line-height: 25px">
              <select style="width: 65px;"
                      v-model="dlvy.cttpc1">
                <option v-for="(cttpc, index) in defCttpc"
                        :key="'cttpc_'+index"
                        :value="cttpc.cd">{{cttpc.nm}}</option>
              </select>
              - <input type="text" style="width: 65px"
                       ref="cttpc2"
                       maxlength="4"
                       @keydown="$onbiLib.onlyNumberKeydown()"
                       @keyup="$onbiLib.onlyNumberKeyup()"
                       v-model="dlvy.cttpc2">
              - <input type="text" style="width: 65px"
                       ref="cttpc3"
                       maxlength="4"
                       @keydown="$onbiLib.onlyNumberKeydown()"
                       @keyup="$onbiLib.onlyNumberKeyup()"
                       v-model="dlvy.cttpc3">
            </td>
          </tr>
          <tr>
            <th class="__left">배송주소</th>
            <td colspan="3">
              <div>
                <input type="text"
                       class="pdr5"
                       tabindex="3"
                       maxlength="6"
                       style="width: 100px !important;padding-right: 5px;"
                       ref="zip"
                       placeholder="우편번호"
                       readonly
                       v-model="dlvy.zip"/>
                <button class="middle _bt-ypurple"
                        style="width:82px;height: 30px;line-height: 30px;padding: 0px 5px;width: 70px;"
                        @click="searchAdresInfo()">
                  <span>검색</span>
                </button>
              </div>
              <div class="mgt5">
                <input type="text"
                       style="width: 90% !important;"
                       tabindex="4"
                       maxlength="50"
                       ref="bassAdres"
                       placeholder="주소를 검색해주세요."
                       readonly
                       v-model="dlvy.bassAdres"/>
              </div>
              <div class="mgt5">
                <input type="text"
                       tabindex="5"
                       maxlength="50"
                       style="width: 90% !important;"
                       ref="detailAdres"
                       v-model="dlvy.detailAdres"
                       placeholder="※ 상세주소 입력이 필요 없을 경우 공란"/>
              </div>
            </td>
          </tr>
          <tr>
            <th class="__left">배송비</th>
            <td colspan="3">{{$onbiLib.addComma(dlvy.dlvyAmount) + '원'}}</td>
          </tr>
          </tbody>
        </table>
        <div class="btn-wrap mgt40 t-line center">
          <button class="big _bt-white" @click="movePrevStep()">
            <span>이전</span>
          </button>
          <button class="big _bt-navy"
                  @click="dlvyNextStep()">
            <span>다음</span>
          </button>
        </div>
      </div>

      <div v-if="step == 3">
        <div class="balance-sort-wrap">
          <div class="balance-sort-con box-type04 mgr5"
               style="width: 35%">
            <div class="__in">
              <div class="entry-cho">
                <span class="label-txt">수령인 및 배송지 정보</span>
              </div>
              <table class="tb-none">
                <colgroup>
                  <col style="width:30%" />
                  <col style="width:auto;" />
                </colgroup>
                <tbody>
                <tr>
                  <th>수령인 이름</th>
                  <td>{{dlvy.rcverNm}}</td>
                </tr>
                <tr>
                  <th>수령인 전화번호</th>
                  <td>{{dlvy.cttpc}}</td>
                </tr>
                <tr>
                  <th>배송 주소</th>
                  <td >({{dlvy.zip}}) {{dlvy.bassAdres}} {{dlvy.detailAdres}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="balance-sort-con box-type04 mgr5">
            <div class="__in">
              <div class="entry-cho">
                  <span class="label-txt">세금계산서 정보</span>
                  <span class="pc01 f-right">(※ 계좌이체/무통장입금인 경우)</span>
              </div>
              <table class="tb-none">
                <colgroup>
                  <col style="width:17%" />
                  <col style="width:auto;" />
                  <col style="width:17%" />
                  <col style="width:auto;" />
                </colgroup>
                <tbody>
                <tr>
                  <th>원명</th>
                  <td>
                    <input type="text"
                           style="width: 150px !important;"
                           ref="insttNm"
                           v-model="taxbil.insttNm">
                  </td>
                  <th>대표자명</th>
                  <td>
                    <input type="text"
                           style="width: 150px !important;"
                           ref="rprsntv"
                           v-model="taxbil.rprsntv">
                  </td>
                </tr>
                <tr>
                  <th>사업자번호</th>
                  <td colspan="3">
                    <input type="text" style="width: 65px"
                           ref="bizrno1"
                           maxlength="3"
                           v-model="taxbil.bizrno1">
                    - <input type="text" style="width: 65px"
                             ref="bizrno2"
                             maxlength="2"
                             v-model="taxbil.bizrno2">
                    - <input type="text" style="width: 65px"
                             ref="bizrno3"
                             maxlength="5"
                             v-model="taxbil.bizrno3">
                  </td>
                </tr>
                <tr>
                  <th>주소</th>
                  <td colspan="3">
                    <input type="text"
                           style="width: 90%;"
                           ref="adres"
                           maxlength="4"
                           v-model="taxbil.adres">
                  </td>
                </tr>
                <tr>
                  <th>업태</th>
                  <td>
                    <input type="text"
                           style="width: 150px !important;"
                           ref="bizcnd"
                           placeholder="업태를 입력하세요."
                           v-model="taxbil.bizcnd">
                  </td>
                  <th>종목</th>
                  <td>
                    <input type="text"
                           style="width: 150px !important;"
                           ref="item"
                           placeholder="종목을 입력하세요."
                           v-model="taxbil.item">
                  </td>
                </tr>
                <tr>
                  <th>이메일</th>
                  <td  colspan="3">
                    <input type="text"
                           style="width: 90%"
                           ref="taxbilEmail"
                           v-model="taxbil.taxbilEmail">
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="balance-sort-wrap mgt20">
          <div class="balance-sort-con box-type04 mgr5">
            <div class="__in">
              <div class="entry-cho"><span class="label-txt">주문 상품 정보</span></div>
              <ul class="balance-sort-wrap" style="margin:-5px;flex-wrap:wrap">
                <li class="balance-sort-con"
                    style="padding:5px;box-sizing: border-box;">
                  <table class="tb-row">
                    <colgroup>
                      <col style="width:13%;">
                      <col style="width:60%;">
                      <col style="width:27%;">
                    </colgroup>
                    <tbody>
                    <tr v-for="(info,index) in saveGoodsList"
                        :key="'buyGoods' + index" >
                      <td style="padding: 5px !important;text-align: center;">
                        <img style="border: 1px solid #efefef;width: 60px;height: 60px"
                             :src="$onbiLib.getImageFileUrl('', info.fileNm, info.savePath, info.extsn, '')">
                      </td>
                      <td>
                        {{ info.goodsNm }}
                        <span class="pdl10 pdr10">
                        ( 금액 : {{ $onbiLib.addComma(info.amount) }}원
                          <span class="pdl10 pdr10">X</span>수량 : {{Number(info.orderQy)}} 개 )
                      </span>
                      </td>
                      <td class="__right"
                          style="font-size: 18px;"
                          v-html="getGoodsSumAmountTxt(info)">
                      </td>
                    </tr>
                    <tr v-if="dlvy.dlvyAmount > 0">
                      <td style="padding: 5px !important;text-align: center;">
                        <img style="border: 1px solid #efefef;width: 60px;height: 60px"
                             src="../../../../assets/app/images/common/i5gam-no-img.png">
                      </td>
                      <td>
                        배송비
                        <span class="pdl10 pdr10">
                        ( 금액 : {{ $onbiLib.addComma(dlvy.dlvyAmount) }}원
                          <span class="pdl10 pdr10"> X </span>수량 : {{dlvy.orderQy}} 개 )
                      </span>
                      </td>
                      <td class="__right"
                          style="font-size: 18px;"
                          v-text=" $onbiLib.addComma(dlvy.dlvyAmount) + '원'">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="balance-sort-wrap mgt20">
          <div class="balance-sort-con box-type04 mgr5">
            <div class="__in">
              <div class="entry-cho"><span class="label-txt">결제 정보</span></div>
              <table class="tb-row">
                <colgroup>
                  <col style="width:20%;">
                  <col style="width:80%;">
                </colgroup>
                <tbody>
                <tr>
                  <th style="text-align: left;">총 결제 금액</th>
                  <td style="font-size: 20px;padding-left: 25px !important;">
                    {{$onbiLib.addComma(chkAllSumAmount) + '원'}}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left;">결제 수단</th>
                  <td>
                    <template v-for="(info, index) in gopaymethodsList">
                      <input type="radio"
                             :key="'gopaymethods_radio' + index"
                             :id="'gopaymethods' + index"
                             :value="info.value"
                             v-model="gopaymethods">
                      <label style="cursor: pointer;"
                             :key="'gopaymethods_label' + index"
                             :for="'gopaymethods' + index">
                        <span class="box"></span>
                        <span class="label-txt mgr15 mgl5">{{ info.name }}</span>
                      </label>
                    </template>
                  </td>
                </tr>
                <tr class="__left"
                    v-if="gopaymethods != 'Card'">
                  <th>세금계산서 발행 여부</th>
                  <td>
                    <input type="checkbox"
                           id="taxbilIsuAt"
                           ref="taxbilIsuAt"
                           true-value="N"
                           false-value="Y"
                           v-model="taxbil.taxbilIsuAt">
                    <label for="taxbilIsuAt"
                           style="cursor: pointer;">
                      <span class="box"></span>
                      <span class="label-txt">발행</span>
                    </label>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="sv-req-terms-bottom"
             style="padding: 10px 30px;">
          <table class="tb-none">
            <tbody>
            <tr>
              <td style="height: 25px; padding: 0px !important; border-bottom: none;">
                <div>
                  <input type="checkbox"
                         id="chkSetleAgreeAt"
                         ref="chkSetleAgreeAt"
                         v-model="chkSetleAgreeAt">
                  <label for="chkSetleAgreeAt"
                         style="cursor: pointer;">
                    <span class="box"></span>
                    <span class="label-txt">결제할 상품 내용을 확인하였으며, 구매에 동의합니다. (전자상거래법 제 8조 2항 근거)</span>
                  </label>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="btn-wrap t-line center" style="border-top:0;">
          <button class="big _bt-white"
                  @click="movePrevStep()">
            <span>이전</span>
          </button>
          <button class="big _bt-navy"
                  @click="orderSetleClick()">
            <span>결제하기</span>
          </button>
        </div>
      </div>

      <div class="grid--con-sub"
           v-if="step == 5">
        <template v-if="inicisResult.code == '000'">
          <div class="sv-req-comp mgb20 mgt20">
            <div class="img-com __icon06"><span>완료 아이콘</span></div>
            <div class="entry-title">
              ** 결제가 완료 되었습니다.<br>
            </div>
          </div>
        </template>
        <template v-if="inicisResult.code != '000'">
          <div class="sv-req-comp">
            <div class="img-com __icon06"><span>완료 아이콘</span></div>
            <div class="entry-title">
              결제에 실패했습니다.<br>
            </div>
            <div class="tit-type6 mgt20">
              다시 결제 시도 후 오류 발생시 고객센터로 연락주시기바랍니다.
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
 * 2.1. Import
 *======================================================================================*/
const mixinSetleAmountCheck = {
  computed: {
    chkAllSumAmount: function () {
      let amount = 0;

      if(location.host.indexOf('i5gam.gulumma.net') > -1){
        this.saveGoodsList.forEach(function (info) {
          amount += (info.amount * info.orderQy) - info.totDscntAmount;
        });

        if (this.dlvy.dlvyAmount > 0) {
          amount += this.dlvy.dlvyAmount;
        }
      }else{
        amount = 1000;
      }

      return amount;
    },
    inicisSetleParam: function(){
      let merchantData = {
        svcCode: 'SBIW02',
        goodsOrderInfo: {
          fcltcd: this.param.fcltInfo.fcltcd,
          goodsGroupCode: this.goodsGroupCode,
          dlvyAt: 'Y',
        },
        goodsOrderDetailList: this.saveGoodsList,
        goodsOrderDlvyInfo: this.dlvy,
        taxbil: this.taxbil,
        mberNo: this.mberInfo.mberNo
      };

      return {
        gopaymethods: this.gopaymethods,
        goodsname: this.goodsSeNm,
        price: this.chkAllSumAmount,
        buyername: this.param.fcltInfo.fcltNm,
        buyertel: this.mberInfo.cttpc,
        buyeremail: this.mberInfo.email,
        merchantData: merchantData,
        finishFunc: this.inicisSetleFinish,
        closeFunc: this.inicisSetlePopupClose,
      }
    },
  },
  data: function(){
    return {
      chkSetleAgreeAt: false,
      taxbil: {
        taxbilIsuAt: 'Y',
        bizrno1: '',
        bizrno2: '',
        bizrno3: '',
        bizrno: '',
        insttNm: '',
        rprsntv: '',
        adres: '',
        bizcnd: '',
        item: '',
        taxbilEmail: '',
      },
      gopaymethods:'Card',
      gopaymethodsList: [
        { name: '신용카드 결제', value: 'Card' },
        { name: '계좌이체', value: 'DirectBank' },
        { name: '무통장입금', value: 'VBank' }
      ],
    }
  },
  methods: {
    orderSetleClick: function(){
      if(!this.chkSetleAgreeAt){
        this.$toasted.show('구매동의에 체크해주시기 바랍니다.');
        return false;
      }

      this.taxbil.bizrno = this.taxbil.bizrno1 + '-' + this.taxbil.bizrno2 + '-' + this.taxbil.bizrno3;

      const popupInfo = {
        se:'modalBlank',
        id:'inicisSetlePopup',
        wid:'820',
        hei:'600',
        tit:'이니시스',
        draggableAt:false,
        param: this.inicisSetleParam
      }

      this.$store.commit('openPopup',popupInfo);
    },
    inicisSetleFinish: function(params, popupIndex){
      this.inicisSetlePopupClose(popupIndex);
      this.inicisResult = params;

      if(this.inicisResult.code == '000'){
        this.step = 5;

        //마이페이지 리스트 초기화 해줘야함!
        if(typeof this.param.callbackFunc != 'undefined') this.param.callbackFunc();
      }else{
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }
    },
    inicisSetlePopupClose: function(popupIndex){
      this.$store.commit('closePopup', popupIndex);
    }
  }
}

const mixinDlvy = {
  computed: {
    dlvyValidInfo: function(){
      let validInfo = {
        at: false,
        trgetNm: '',
        msg: ''
      }

      if(this.dlvy.rcverNm == '' && !validInfo.at){
        validInfo.at = true;
        validInfo.trgetNm = 'rcverNm';
        validInfo.msg = '수령인 이름을 입력해주세요.';
      }

      //수령인 연락처
      if(this.dlvy.cttpc1 == '' && !validInfo.at
          || this.dlvy.cttpc2 == '' && !validInfo.at
            || this.dlvy.cttpc2.length < 3 && !validInfo.at
              || this.dlvy.cttpc3 == '' && !validInfo.at
                || this.dlvy.cttpc3.length < 4 && !validInfo.at){
        validInfo.at = true;
        validInfo.trgetNm = 'cttpc2';
        validInfo.msg = '수령인 연락처를 입력해주세요.';
      }

      if(this.dlvy.zip == '' && !validInfo.at){
        validInfo.at = true;
        validInfo.trgetNm = 'zip';
        validInfo.msg = '우편번호를 검색해주세요.';
      }

      if(this.dlvy.bassAdres == '' && !validInfo.at){
        validInfo.at = true;
        validInfo.trgetNm = 'bassAdres';
        validInfo.msg = '주소를 검색해주세요.';
      }

      return validInfo;
    },
    detectorChkAt: function(){
      let chkAt = false;

      const detectorInfo = this.saveGoodsList.find(function(info){
       return info.goodsNo == '1' || info.goodsNo == '2'
      });

      if(detectorInfo != null) chkAt = true;

      return chkAt;
    }
  },
  data: function(){
    return {
      dlvy: {
        rcverNm: '',
        zip: '',
        bassAdres: '',
        detailAdres: '',
        cttpc: '',
        cttpc1: '',
        cttpc2: '',
        cttpc3: '',
        orderQy: 1,
        dlvyAmount: 0, //배송비 무조건 3000원(지역별 추가금액 존재)
        dlvyMsg: '',
        hdryCmpnyCode: '',
      },
      defCttpc: [
        {cd:'02', nm: '02'},
        {cd:'031', nm: '031'},
        {cd:'032', nm: '032'},
        {cd:'033', nm: '033'},
        {cd:'041', nm: '041'},
        {cd:'042', nm: '042'},
        {cd:'043', nm: '043'},
        {cd:'044', nm: '044'},
        {cd:'051', nm: '051'},
        {cd:'052', nm: '052'},
        {cd:'053', nm: '053'},
        {cd:'054', nm: '054'},
        {cd:'055', nm: '055'},
        {cd:'061', nm: '061'},
        {cd:'062', nm: '062'},
        {cd:'063', nm: '063'},
        {cd:'064', nm: '064'},
        {cd:'010', nm: '010'},
        {cd:'011', nm: '011'},
        {cd:'016', nm: '016'},
        {cd:'017', nm: '017'},
        {cd:'018', nm: '018'},
        {cd:'019', nm: '019'},
      ]
    }
  },
  methods: {
    setDlvyInfo: function(){
      this.dlvy.dlvyAmount = 0;

      if(this.dlvy.zip == ''){  //최초셋팅인 경우에만 최근배송지 조회
        this.searchLastDlvyInfo().then(function(lastDlvyInfo){
          if(lastDlvyInfo != null
            && confirm("최근 배송지를 불러 오시겠습니까?")){
            let cttpcList = lastDlvyInfo.cttpc.split('-');

            this.dlvy.rcverNm = lastDlvyInfo.rcverNm;
            this.dlvy.zip = lastDlvyInfo.zip.replaceAll('-','');
            this.dlvy.bassAdres = lastDlvyInfo.bassAdres;
            this.dlvy.detailAdres = lastDlvyInfo.detailAdres;
            this.dlvy.cttpc1 = cttpcList.length > 0 ? cttpcList[0] : '';
            this.dlvy.cttpc2 = cttpcList.length > 1 ? cttpcList[1] : '';
            this.dlvy.cttpc3 = cttpcList.length > 2 ? cttpcList[2] : '';

            if(!this.detectorChkAt) this.searchDlvyAmountInfo();
          }else{
            //주문자 전화번호로 기본 셋팅
            let cttpcList = this.mberInfo.cttpc.split('-');

            this.dlvy.rcverNm = this.param.fcltInfo.fcltNm;
            this.dlvy.cttpc1 = cttpcList.length > 0 ? cttpcList[0] : '';
            this.dlvy.cttpc2 = cttpcList.length > 1 ? cttpcList[1] : '';
            this.dlvy.cttpc3 = cttpcList.length > 2 ? cttpcList[2] : '';
          }
        }.bind(this));
      }else{//주소 셋팅 후에 상품 구매를 수정한 경우 배송비 다시셋팅
        if(!this.detectorChkAt) this.searchDlvyAmountInfo();
      }
    },
    searchLastDlvyInfo: function(){
      return new Promise(function(resolve, reject){
        this.axios.post('/i5gam/goods/searchLastDlvyInfo.act',{
          fcltcd: this.param.fcltInfo.fcltcd,
        }).then(function(response) {
          resolve(response.data.lastDlvyInfo);
        }.bind(this)).catch(function(e) {
          reject(e);
        }.bind(this));
      }.bind(this));
    },
    searchAdresInfo: function(){
      const _this = this;

      new window.daum.Postcode({
        oncomplete: function(data) {
          _this.dlvy.zip = data.zonecode;
          _this.dlvy.bassAdres = data.address;

          //리더기나 리더기 설치비 구매한 경우는 배송비 없음.
          if(!_this.detectorChkAt) {
            _this.searchDlvyAmountInfo();
          }
        }
      }).open();
    },
    searchDlvyAmountInfo: function(){
      this.axios.post('/i5gam/goods/searchDlvyAmountInfo.act', {
        //zip: zonecode,
        zip: this.dlvy.zip
      }).then(function(response){
        const dlvyAmountInfo = response.data.dlvyAmountInfo;

        //기본배송비 3000원
        this.dlvy.dlvyAmount = 3000;

        //추가배송비 존재하면 배송비 더해줌.
        if(dlvyAmountInfo != null) this.dlvy.dlvyAmount += Number(dlvyAmountInfo.aditDlvyamount);
      }.bind(this)).catch(function(e){
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    dlvyNextStep: function(){
      //배송 validation 추가해야함
      if(this.dlvyValidInfo.at){
        this.$toasted.show(this.dlvyValidInfo.msg);
        //this.$refs[this.dlvyValidInfo.trgetNm][0].focus();
        return false;
      }

      this.dlvy.cttpc = this.dlvy.cttpc1 + '-' + this.dlvy.cttpc2 + '-' + this.dlvy.cttpc3;
      //배송비 무료인 경우 택배회사 AS기사로 셋팅
      if(this.dlvy.dlvyAmount == 0) this.dlvy.hdryCmpnyCode = 'IAS';

      //세금계산서 정보 셋팅
      let bizrno = this.param.fcltInfo.bizrno.replaceAll('-', '');
      this.taxbil.bizrno1 = bizrno.substr(0, 3);
      this.taxbil.bizrno2 = bizrno.substr(3, 2);
      this.taxbil.bizrno3 = bizrno.substr(5, 5);
      this.taxbil.insttNm = this.param.fcltInfo.fcltNm;
      this.taxbil.rprsntv = this.mberInfo.mberNm;
      this.taxbil.adres = this.dlvy.bassAdres + ' ' + this.dlvy.detailAdres;
      this.taxbil.taxbilEmail = this.mberInfo.email;

      this.step += 1;
    }
  },
}

const mixinGoods = {
  computed: {
    chkGoodsSumAmount: function () {
      let amount = 0;
      this.goods.goodsList.forEach(function (info) {
        if (info.chkAt) amount += (info.amount * info.orderQy) - info.totDscntAmount;
      });

      return amount;
    },
    goodsBuyValidInfo: function(){
      let validInfo = {
        at: false,
        trgetNm: '',
        msg: ''
      }

      if(this.chkGoodsSumAmount <= 0){
        validInfo.at = true;
        validInfo.trgetNm = 'goodsAmount0';
        validInfo.msg = '1개 이상의 상품 선택 및 수량을 입력해주세요.';
      }else {
        let goodsIndex = this.goods.goodsList.findIndex(function(info){
          return info.chkAt && info.orderQy == 0;
        });
        if(goodsIndex != -1){
          validInfo.at = true;
          validInfo.trgetNm = 'goodsAmount' + goodsIndex;
          validInfo.msg = '선택을 취소하시거나 수량을 입력해주세요.';
        }
      }

      return validInfo;
    },
    saveGoodsList: function(){
      return this.goods.goodsList.filter(function(info){
        info.orderAmount = info.amount;
        return info.chkAt && info.orderQy > 0;
      })
    }
  },
  data: function(){
    return {
      goods: {
        goodsList: new Array(),
      }
    }
  },
  methods: {
    setOrderDscntAmount: function(info){
      //할인 금액 존재하는 경우 셋팅(※ 현재 금액할인은 어떻게 될지 미지수...일단은 그냥 할인 금액 넣는다.)
      if(info.chkAt && info.orderQy > 0 && info.dscntSeCode != ''){
        info.orderDscntAmount = info.dscntAmount;
        info.totDscntAmount = info.dscntAmount;

        if(info.dscntSeCode == '002') info.totDscntAmount = info.dscntAmount*info.orderQy;
      }else{
        info.orderDscntAmount = 0;
        info.totDscntAmount = 0;
      }
    },
    getGoodsSumAmountTxt: function(info){
      let amountTxt = '0원';

      if(info.chkAt){
        let totAmount = info.amount * info.orderQy;

        if(info.totDscntAmount > 0) {
          let orderSumAmount = totAmount - info.totDscntAmount;
          amountTxt = '<span style="text-decoration: line-through;color: red;font-size: 16px;">' + this.$onbiLib.addComma(totAmount)+ '원</span><br/>';
          amountTxt += '<span>' + this.$onbiLib.addComma(orderSumAmount) + '원</span>';
        }else{
          amountTxt = this.$onbiLib.addComma(totAmount) + '원';
        }
      }

      return amountTxt;
    },
    getGoodsSumAmount: function(info){
      let amount = 0;
      if(info.chkAt) amount = info.amount * info.orderQy;

      return amount;
    },
    goodsChkChange: function(index){
      if(index == 0){
        this.goods.goodsList[1].chkAt = this.goods.goodsList[index].chkAt;

        //리더기 선택에 따른 설치비 수량 셋팅
        if(this.goods.goodsList[index].chkAt){
          this.goods.goodsList[1].orderQy = 1;
        }else{
          this.goods.goodsList[1].orderQy = 0;
        }
      }else if(index == 1){
        //리더기 선택된 경우는 설치비 반드시 구매
        if(this.goods.goodsList[0].chkAt) {
          this.$toasted.show('아이오감 리더기 구매시 설치비는 반드시 구매하셔야합니다.');
          this.$nextTick(function(){
            this.goods.goodsList[index].chkAt = true;
            this.goods.goodsList[index].orderQy = 1;
          });
        }
      }

      //체크여부에 따른 수량 셋팅
      if(this.goods.goodsList[index].chkAt){
        this.goods.goodsList[index].orderQy = 1;
        this.setOrderDscntAmount(this.goods.goodsList[index]);
      }else{
        this.goods.goodsList[index].orderQy = 0;
      }
    },
    goodsNextStep: function(){
      if(this.goodsBuyValidInfo.at){
        this.$toasted.show(this.goodsBuyValidInfo.msg);
        this.$refs[this.goodsBuyValidInfo.trgetNm][0].focus();
        return false;
      }

      this.setDlvyInfo();
      this.step += 1;
    },
  }
}

export default {
  /*======================================================================================*
   * 2.2. 뷰 컴포넌트 명칭
   *======================================================================================*/
  nm: 'addOrderPopup',
  props: ['param','index'],
  mixins : [mixinGoods, mixinDlvy, mixinSetleAmountCheck],
  /*======================================================================================*
   * 2.3. 지역 변수
   *======================================================================================*/
  data: function () {
    return {
      showAt: false,
      step: 1,
      goodsSeNm: '추가구매상품',
      goodsGroupCode: '200', //추가 구매인 경우 200
      inicisResult: {},
    }
  },
  computed : {
    mberInfo : function(){
      return this.$store.getters.getMberInfo;
    },
    dayInfo: function(){
      return this.$store.getters.getDayInfo;
    },
  },
  /*======================================================================================*
   * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
   *======================================================================================*/
  methods: {
    init: function () {
      /*
      let searchInfo = {cdGrp: 'SMC'};
      this.$onbiLib.searchCmmnCodeList(searchInfo).then(function(codeList){
        this.setleMthCodeList = codeList.filter(function(info){
          return info.cd.substr(0, 1) == '1';
        });

        this.searchGoodsList();
      }.bind(this));
      */

      this.searchGoodsList();
    },
    searchGoodsList: function(){
      this.axios.post('/i5gam/goods/searchGoodsList.act',{
        goodsGroupCode: this.goodsGroupCode
      }).then(function(response) {
        let goodsList = response.data.goodsList;
        goodsList.forEach(function(info){
          info.chkAt = false;
          info.orderQy = 0;
          info.orderDscntAmount = 0;
          info.totDscntAmount = 0;
        });

        this.goods.goodsList = goodsList;
        this.showAt = true;
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    movePrevStep: function(){
      this.step -= 1;
    }
  },
  /*======================================================================================*
   * 2.4. Vue Life Cycle
   *======================================================================================*/
  mounted: function () {
    this.init();
  }
}
</script>

<!-------------------------------------------------------------------------------------
- 3. 뷰 스타일 block
--------------------------------------------------------------------------------------->
<style scoped>
.tb-none th,td {
  border-bottom: 1px solid #e0e0e0;
}
</style>